/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TelusImport } from './routes/telus'
import { Route as SpringHealthImport } from './routes/spring-health'
import { Route as LoginImport } from './routes/login'
import { Route as GsAdminImport } from './routes/gs-admin'
import { Route as TelusThankYouImport } from './routes/telus/thank-you'
import { Route as SpringHealthVerifyImport } from './routes/spring-health/verify'
import { Route as SpringHealthThankYouImport } from './routes/spring-health/thank-you'
import { Route as SpringHealthRegisterImport } from './routes/spring-health/register'
import { Route as MembersSplatImport } from './routes/members.$'
import { Route as GsAdminMembersImport } from './routes/gs-admin/members'
import { Route as GsAdminMembersIndexImport } from './routes/gs-admin/members.index'
import { Route as TelusRegisterEnrollImport } from './routes/telus/register.enroll'
import { Route as SpringHealthRegisterSignUpImport } from './routes/spring-health/register.sign-up'
import { Route as SpringHealthRegisterLogInImport } from './routes/spring-health/register.log-in'
import { Route as SpringHealthRegisterEnrollImport } from './routes/spring-health/register.enroll'
import { Route as GsAdminMembersSearchImport } from './routes/gs-admin/members.search'
import { Route as GsAdminMembersEnrollImport } from './routes/gs-admin/members.enroll'

// Create/Update Routes

const TelusRoute = TelusImport.update({
  path: '/telus',
  getParentRoute: () => rootRoute,
} as any)

const SpringHealthRoute = SpringHealthImport.update({
  path: '/spring-health',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const GsAdminRoute = GsAdminImport.update({
  path: '/gs-admin',
  getParentRoute: () => rootRoute,
} as any)

const TelusThankYouRoute = TelusThankYouImport.update({
  path: '/thank-you',
  getParentRoute: () => TelusRoute,
} as any)

const SpringHealthVerifyRoute = SpringHealthVerifyImport.update({
  path: '/verify',
  getParentRoute: () => SpringHealthRoute,
} as any)

const SpringHealthThankYouRoute = SpringHealthThankYouImport.update({
  path: '/thank-you',
  getParentRoute: () => SpringHealthRoute,
} as any)

const SpringHealthRegisterRoute = SpringHealthRegisterImport.update({
  path: '/register',
  getParentRoute: () => SpringHealthRoute,
} as any)

const MembersSplatRoute = MembersSplatImport.update({
  path: '/members/$',
  getParentRoute: () => rootRoute,
} as any)

const GsAdminMembersRoute = GsAdminMembersImport.update({
  path: '/members',
  getParentRoute: () => GsAdminRoute,
} as any)

const GsAdminMembersIndexRoute = GsAdminMembersIndexImport.update({
  path: '/',
  getParentRoute: () => GsAdminMembersRoute,
} as any)

const TelusRegisterEnrollRoute = TelusRegisterEnrollImport.update({
  path: '/register/enroll',
  getParentRoute: () => TelusRoute,
} as any)

const SpringHealthRegisterSignUpRoute = SpringHealthRegisterSignUpImport.update(
  {
    path: '/sign-up',
    getParentRoute: () => SpringHealthRegisterRoute,
  } as any,
)

const SpringHealthRegisterLogInRoute = SpringHealthRegisterLogInImport.update({
  path: '/log-in',
  getParentRoute: () => SpringHealthRegisterRoute,
} as any)

const SpringHealthRegisterEnrollRoute = SpringHealthRegisterEnrollImport.update(
  {
    path: '/enroll',
    getParentRoute: () => SpringHealthRegisterRoute,
  } as any,
)

const GsAdminMembersSearchRoute = GsAdminMembersSearchImport.update({
  path: '/search',
  getParentRoute: () => GsAdminMembersRoute,
} as any)

const GsAdminMembersEnrollRoute = GsAdminMembersEnrollImport.update({
  path: '/enroll',
  getParentRoute: () => GsAdminMembersRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/gs-admin': {
      id: '/gs-admin'
      path: '/gs-admin'
      fullPath: '/gs-admin'
      preLoaderRoute: typeof GsAdminImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/spring-health': {
      id: '/spring-health'
      path: '/spring-health'
      fullPath: '/spring-health'
      preLoaderRoute: typeof SpringHealthImport
      parentRoute: typeof rootRoute
    }
    '/telus': {
      id: '/telus'
      path: '/telus'
      fullPath: '/telus'
      preLoaderRoute: typeof TelusImport
      parentRoute: typeof rootRoute
    }
    '/gs-admin/members': {
      id: '/gs-admin/members'
      path: '/members'
      fullPath: '/gs-admin/members'
      preLoaderRoute: typeof GsAdminMembersImport
      parentRoute: typeof GsAdminImport
    }
    '/members/$': {
      id: '/members/$'
      path: '/members/$'
      fullPath: '/members/$'
      preLoaderRoute: typeof MembersSplatImport
      parentRoute: typeof rootRoute
    }
    '/spring-health/register': {
      id: '/spring-health/register'
      path: '/register'
      fullPath: '/spring-health/register'
      preLoaderRoute: typeof SpringHealthRegisterImport
      parentRoute: typeof SpringHealthImport
    }
    '/spring-health/thank-you': {
      id: '/spring-health/thank-you'
      path: '/thank-you'
      fullPath: '/spring-health/thank-you'
      preLoaderRoute: typeof SpringHealthThankYouImport
      parentRoute: typeof SpringHealthImport
    }
    '/spring-health/verify': {
      id: '/spring-health/verify'
      path: '/verify'
      fullPath: '/spring-health/verify'
      preLoaderRoute: typeof SpringHealthVerifyImport
      parentRoute: typeof SpringHealthImport
    }
    '/telus/thank-you': {
      id: '/telus/thank-you'
      path: '/thank-you'
      fullPath: '/telus/thank-you'
      preLoaderRoute: typeof TelusThankYouImport
      parentRoute: typeof TelusImport
    }
    '/gs-admin/members/enroll': {
      id: '/gs-admin/members/enroll'
      path: '/enroll'
      fullPath: '/gs-admin/members/enroll'
      preLoaderRoute: typeof GsAdminMembersEnrollImport
      parentRoute: typeof GsAdminMembersImport
    }
    '/gs-admin/members/search': {
      id: '/gs-admin/members/search'
      path: '/search'
      fullPath: '/gs-admin/members/search'
      preLoaderRoute: typeof GsAdminMembersSearchImport
      parentRoute: typeof GsAdminMembersImport
    }
    '/spring-health/register/enroll': {
      id: '/spring-health/register/enroll'
      path: '/enroll'
      fullPath: '/spring-health/register/enroll'
      preLoaderRoute: typeof SpringHealthRegisterEnrollImport
      parentRoute: typeof SpringHealthRegisterImport
    }
    '/spring-health/register/log-in': {
      id: '/spring-health/register/log-in'
      path: '/log-in'
      fullPath: '/spring-health/register/log-in'
      preLoaderRoute: typeof SpringHealthRegisterLogInImport
      parentRoute: typeof SpringHealthRegisterImport
    }
    '/spring-health/register/sign-up': {
      id: '/spring-health/register/sign-up'
      path: '/sign-up'
      fullPath: '/spring-health/register/sign-up'
      preLoaderRoute: typeof SpringHealthRegisterSignUpImport
      parentRoute: typeof SpringHealthRegisterImport
    }
    '/telus/register/enroll': {
      id: '/telus/register/enroll'
      path: '/register/enroll'
      fullPath: '/telus/register/enroll'
      preLoaderRoute: typeof TelusRegisterEnrollImport
      parentRoute: typeof TelusImport
    }
    '/gs-admin/members/': {
      id: '/gs-admin/members/'
      path: '/'
      fullPath: '/gs-admin/members/'
      preLoaderRoute: typeof GsAdminMembersIndexImport
      parentRoute: typeof GsAdminMembersImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  GsAdminRoute: GsAdminRoute.addChildren({
    GsAdminMembersRoute: GsAdminMembersRoute.addChildren({
      GsAdminMembersEnrollRoute,
      GsAdminMembersSearchRoute,
      GsAdminMembersIndexRoute,
    }),
  }),
  LoginRoute,
  SpringHealthRoute: SpringHealthRoute.addChildren({
    SpringHealthRegisterRoute: SpringHealthRegisterRoute.addChildren({
      SpringHealthRegisterEnrollRoute,
      SpringHealthRegisterLogInRoute,
      SpringHealthRegisterSignUpRoute,
    }),
    SpringHealthThankYouRoute,
    SpringHealthVerifyRoute,
  }),
  TelusRoute: TelusRoute.addChildren({
    TelusThankYouRoute,
    TelusRegisterEnrollRoute,
  }),
  MembersSplatRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/gs-admin",
        "/login",
        "/spring-health",
        "/telus",
        "/members/$"
      ]
    },
    "/gs-admin": {
      "filePath": "gs-admin.tsx",
      "children": [
        "/gs-admin/members"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/spring-health": {
      "filePath": "spring-health.tsx",
      "children": [
        "/spring-health/register",
        "/spring-health/thank-you",
        "/spring-health/verify"
      ]
    },
    "/telus": {
      "filePath": "telus.tsx",
      "children": [
        "/telus/thank-you",
        "/telus/register/enroll"
      ]
    },
    "/gs-admin/members": {
      "filePath": "gs-admin/members.tsx",
      "parent": "/gs-admin",
      "children": [
        "/gs-admin/members/enroll",
        "/gs-admin/members/search",
        "/gs-admin/members/"
      ]
    },
    "/members/$": {
      "filePath": "members.$.tsx"
    },
    "/spring-health/register": {
      "filePath": "spring-health/register.tsx",
      "parent": "/spring-health",
      "children": [
        "/spring-health/register/enroll",
        "/spring-health/register/log-in",
        "/spring-health/register/sign-up"
      ]
    },
    "/spring-health/thank-you": {
      "filePath": "spring-health/thank-you.tsx",
      "parent": "/spring-health"
    },
    "/spring-health/verify": {
      "filePath": "spring-health/verify.tsx",
      "parent": "/spring-health"
    },
    "/telus/thank-you": {
      "filePath": "telus/thank-you.tsx",
      "parent": "/telus"
    },
    "/gs-admin/members/enroll": {
      "filePath": "gs-admin/members.enroll.tsx",
      "parent": "/gs-admin/members"
    },
    "/gs-admin/members/search": {
      "filePath": "gs-admin/members.search.tsx",
      "parent": "/gs-admin/members"
    },
    "/spring-health/register/enroll": {
      "filePath": "spring-health/register.enroll.tsx",
      "parent": "/spring-health/register"
    },
    "/spring-health/register/log-in": {
      "filePath": "spring-health/register.log-in.tsx",
      "parent": "/spring-health/register"
    },
    "/spring-health/register/sign-up": {
      "filePath": "spring-health/register.sign-up.tsx",
      "parent": "/spring-health/register"
    },
    "/telus/register/enroll": {
      "filePath": "telus/register.enroll.tsx",
      "parent": "/telus"
    },
    "/gs-admin/members/": {
      "filePath": "gs-admin/members.index.tsx",
      "parent": "/gs-admin/members"
    }
  }
}
ROUTE_MANIFEST_END */
